// extracted by mini-css-extract-plugin
export default {"container":"DSIFlags_container__Tv+94","list":"DSIFlags_list__9Ons5"};